import { render } from "./ComUploadFile.vue?vue&type=template&id=a478da5e&ts=true"
import script from "./ComUploadFile.vue?vue&type=script&lang=ts"
export * from "./ComUploadFile.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__